export default __webpack_public_path__ + "static/chi-2312a9c87739d8e9a3de6a438a079a7b.png";